__turbopack_context__.v({
  "cats": "style-module-scss-module__njX1bW__cats",
  "item": "style-module-scss-module__njX1bW__item",
  "label": "style-module-scss-module__njX1bW__label",
  "title": "style-module-scss-module__njX1bW__title",
});
